@if (bewegung(); as bewegung) {
  <div class="flex flex-col overflow-auto full-width w-full z-[0] lg:-mt-3 relative">
    @if ((loading$ | async) === false) {
      <div class="flex flex-col w-full px-4 pt-4 -mt-2">
        <soft-artikel-header [bewegung]="bewegung" [paletteEinzelEingabe]="paletteEinzelEingabe"></soft-artikel-header>
        <div class="font-bold text-sm text-primary-400 mt-1 mb-1">
          {{'#LLR_KOMMISSIONIERUNG.PALETTENAUSWAHL.TITEL_VORHANDENE_PALETTEN' | translate}}
        </div>
        @if ($any((paletten$ | async))?.length > 0) {
          @for (palette of (paletten$ | async); track palette) {
            <div class="soft-card rounded-sm flex flex-row w-full items-center justify-between cursor-pointer mb-3 !p-3"
              (click)="navigateToNextStepWithSelectedPalette(palette)">
              <div class="flex flex-row w-full justify-between">
                <div class="flex flex-col w-2/3 gap-2">
                  <div class="flex flex-row w-full justify-between">
                    <div class="text-sm text-gray-400">
                      {{palette?.ssccnummer}}
                    </div>
                  </div>
                  <div class="flex flex-row w-full gap-4 font-semibold">
                    <div>
                      {{getPaletteArt(palette)?.charge?.charge ?? 'CHARGE'}}
                    </div>
                    <div>
                      {{(getPaletteArt(palette)?.mhd ?? 'MHD') | format: 'DATE.DEFAULT'}}
                    </div>
                  </div>
                </div>
                <div class="flex flex-row w-1/3 gap-4 self-center justify-end">
                  <div class="flex flex-col gap-2 justify-center items-end text-end font-semibold">
                    <div>
                      {{palette?.lagerplatz?.lagerplatz ?? 'LAGERPLATZ'}}
                    </div>
                    <div>
                      {{getPaletteArt(palette)?.menge_offen ?? 0}} {{getPaletteArt(palette)?.arteh?.arteh}}
                    </div>
                  </div>
                  <div class="flex flex-col max-w-fit self-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          }
        } @else {
          <div class="flex text-sm text-lighter w-full justify-center items-center mt-3">
            {{'#LLR_KOMMISSIONIERUNG.PALETTENAUSWAHL.LABEL_KEINE_PALETTEN_VORHANDEN' | translate}}
          </div>
        }
      </div>
    } @else {
      <div class="p-4">
        <div class="flex flex-col pb-5 gap-2">
          <div class="h-4 w-16 skeleton rounded"></div>
          <div class="flex soft-card rounded w-full h-24 mb-3">
            <div class="flex flex-col gap-2 items-start pb-1.5 pt-2">
              <div class="h-4 w-20 skeleton rounded"></div>
              <div class="h-4 w-24 skeleton rounded"></div>
              <div class="h-4 w-36 skeleton rounded"></div>
            </div>
          </div>
          <div class="h-4 w-16 skeleton rounded"></div>
          <div class="flex soft-card rounded w-full h-16" *softRepeat="5">
            <div class="flex flex-col gap-2 items-start">
              <div class="h-4 w-20 skeleton rounded"></div>
              <div class="h-4 w-24 skeleton rounded"></div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

